import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'outline';
type Size = 'sm' | 'md' | 'lg';

const variantClasses: Record<Variant, string> = {
  primary:
    'bg-seal-500 text-paper-50 shadow-sm shadow-seal-500/20 hover:bg-seal-600 hover:shadow-md hover:shadow-seal-500/25 disabled:bg-seal-500/30 disabled:text-paper-50/50 disabled:shadow-none',
  secondary:
    'bg-paper-100 text-manuscript-ink shadow-sm hover:bg-paper-200 hover:shadow-md disabled:text-manuscript-ink-faint disabled:shadow-none',
  ghost: 'text-manuscript-ink-soft hover:bg-paper-200 disabled:text-manuscript-ink-faint',
  outline:
    'border border-manuscript-line-strong bg-transparent text-manuscript-ink hover:border-seal-500 hover:text-seal-500 disabled:text-manuscript-ink-faint disabled:hover:border-manuscript-line-strong',
};

const sizeClasses: Record<Size, string> = {
  sm: 'px-4 py-2 text-xs',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-7 py-3.5 text-base',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

export function Button({ variant = 'primary', size = 'md', className = '', ...props }: ButtonProps) {
  return (
    <button
      className={`font-manuscript inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-all disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-seal-500/50 focus-visible:ring-offset-1 ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      {...props}
    />
  );
}
